import Image from 'next/image';

/**
 * Brand wordmark — "MCWorldTools" set in Baloo 2 (font-display), tri-color:
 * MC white · World emerald · Tools violet. Text-based so it scales crisply and
 * stays selectable. Use in the header lockup, footer, and anywhere the brand
 * name appears as type.
 */
export function Wordmark({ className = '' }: { className?: string }) {
  return (
    <span className={`font-display font-extrabold tracking-tight leading-none ${className}`}>
      <span className="text-white">MC</span>
      <span className="text-emerald-400">World</span>
      <span className="text-violet-400">Tools</span>
    </span>
  );
}

/**
 * Header lockup — the detailed hero mark (block + pickaxe/shovel/cubes) + wordmark.
 * The hero mark is illustration-detailed, so it's rendered at ≥40px (never smaller,
 * per the brand brief — below that it turns to mush; the tiny browser-tab favicon
 * uses the simplified block instead). When `collapsed`, only the mark shows, sized
 * to the 64px rail. The mark's alt is empty when the wordmark text is present.
 */
export default function Logo({
  collapsed = false,
  className = '',
}: {
  collapsed?: boolean;
  className?: string;
}) {
  const size = collapsed ? 40 : 44;
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <Image
        src="/brand/logo.png"
        alt={collapsed ? 'MCWorldTools' : ''}
        width={size}
        height={size}
        className="flex-shrink-0"
        priority
      />
      {!collapsed && <Wordmark className="text-xl" />}
    </span>
  );
}
